import { useState } from "react";

export const FAQ = (props) => {
  const [openIndex, setOpenIndex] = useState(0);

  return (
    <div id="faq" className="text-center">
      <div className="container">
        <div className="section-title">
          <h2>{props.data ? props.data.title : 'Korduma Kippuvad Küsimused'}</h2>
          <p>{props.data ? props.data.paragraph : 'Loading...'}</p>
        </div>
        <div className="row">
          <div className="col-md-8 col-md-offset-2">
            {props.data ?
              props.data.questions.map((item, index) => (
                <div
                  className={`faq-item${openIndex === index ? ' open' : ''}`}
                  key={`faq-${index}`}
                >
                  <button
                    type="button"
                    className="faq-question"
                    onClick={() => setOpenIndex(openIndex === index ? -1 : index)}
                    aria-expanded={openIndex === index}
                  >
                    <span>{item.question}</span>
                    <i className={`fa ${openIndex === index ? 'fa-chevron-up' : 'fa-chevron-down'}`} aria-hidden="true"></i>
                  </button>
                  <div className="faq-answer">
                    <p>{item.answer}</p>
                  </div>
                </div>
              ))
              : 'Loading...'}
          </div>
        </div>
      </div>
    </div>
  );
}
